export type PerformanceMode = 'auto' | 'minimal';

export const PERFORMANCE_MODE_KEY = 'tension_performance_mode';

export function readPerformanceMode(): PerformanceMode {
  if (typeof window === 'undefined') return 'auto';
  try {
    return localStorage.getItem(PERFORMANCE_MODE_KEY) === 'minimal' ? 'minimal' : 'auto';
  } catch {
    return 'auto';
  }
}

export function writePerformanceMode(mode: PerformanceMode): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(PERFORMANCE_MODE_KEY, mode);
  } catch {
    // noop
  }
}

export function applyPerformanceMode(mode: PerformanceMode): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-performance-mode', mode);
}

export function initializePerformanceMode(): PerformanceMode {
  const mode = readPerformanceMode();
  applyPerformanceMode(mode);
  return mode;
}
